<!-- Header -->
<div class="card-header card-header-grid">
  <!-- Search -->
  <div class="input-group input-lined" role="search">
    <div class="input-group-text">
      <i role="img" class="fa fa-search text-muted" aria-hidden="true"></i>
    </div>
    <input
      class="form-control"
      type="search"
      placeholder="{{ 'general.search' | translate }} "
      [(ngModel)]="filterTerm"
      (ngModelChange)="onSearch($event)"
      attr.aria-label="{{ 'general.search' | translate }}"
    />
  </div>
  <!-- End Search -->

  <div
    class="spinner-border"
    role="status"
    attr.aria-label="{{ 'general.loading' | translate }}"
    *ngIf="isLoading"
  >
  </div>

  <div class="d-flex justify-content-end align-items-center">
    <div>
      <span>
        {{ total$ | async }}
        {{ 'general.total' | translate }}
      </span>
    </div>

    <div class="btn-group ms-3" dropdown *ngIf="bulkActions?.length">
      <button
        class="btn btn-sm btn-white dropdown-toggle"
        type="button"
        dropdownToggle
      >
        {{ 'general.bulkActions' | translate }}
      </button>

      <ul *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu">
        <li *ngFor="let bulkAction of bulkActions">
          <a
            href="javascript:;"
            class="dropdown-item"
            (click)="onClickBulkAction(bulkAction)"
          >
            {{ 'general.' + bulkAction | translate }}
          </a>
        </li>
      </ul>
    </div>
  </div>

  <!-- End Row -->
</div>
<!-- End Header -->

<!-- Table -->
<div class="table-responsive">
  <table
    class="table table-borderless table-striped table-nowrap"
    [mfData]="tableData | recursiveFilter: filterTerm"
    #dataTable="mfDataTable"
    [mfRowsOnPage]="25"
  >
    <thead class="table-light">
      <tr>
        <th
          scope="col"
          (click)="onToggleAllChecked()"
          class="cursor-pointer"
          style="max-width: 60px"
        >
          <input
            type="checkbox"
            class="form-check-input"
            [checked]="allCheckedToggle"
            attr.aria-label="{{ 'general.selectAll' | translate }}"
          />
        </th>
        <th scope="col" style="width: 70%">
          <mfDefaultSorter by="description">
            {{ 'organizationModule.description' | translate }}
          </mfDefaultSorter>
        </th>
        <th scope="col" style="width: 30%">
          <mfDefaultSorter by="commercialCode">
            {{ 'general.commercialCode' | translate }}
          </mfDefaultSorter>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr
        *ngFor="let item of dataTable.data; let i = index"
        class="cursor-pointer"
      >
        <td (click)="onCheckRow(item)" class="cursor-pointer">
          <input
            type="checkbox"
            class="form-check-input"
            [checked]="this.checkedIds.get(item.id)"
            attr.aria-label="{{ 'wcag.selectThis' | translate }}"
          />
        </td>
        <td (click)="onRowClicked(item)">
          {{ item.description }}
        </td>
        <td (click)="onRowClicked(item)">
          {{ item.commercialCode }}
        </td>
      </tr>
    </tbody>
    <tfoot>
      <tr>
        <td colspan="6" class="pb-0">
          <mfBootstrapPaginator
            [rowsOnPageSet]="[25, 50, 100]"
          ></mfBootstrapPaginator>
        </td>
      </tr>
    </tfoot>
  </table>
</div>
